'use client';

import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
interface CustomConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
}
export function ConfirmationModalStandard({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = "Delete",
  cancelText = "Cancel"
}: CustomConfirmModalProps) {
  return <AlertDialog open={isOpen} onOpenChange={onClose} data-sentry-element="AlertDialog" data-sentry-component="ConfirmationModalStandard" data-sentry-source-file="confirm-modal-standard.tsx">
      <AlertDialogContent data-sentry-element="AlertDialogContent" data-sentry-source-file="confirm-modal-standard.tsx">
        <AlertDialogHeader data-sentry-element="AlertDialogHeader" data-sentry-source-file="confirm-modal-standard.tsx">
          <AlertDialogTitle data-sentry-element="AlertDialogTitle" data-sentry-source-file="confirm-modal-standard.tsx">{title}</AlertDialogTitle>
          <AlertDialogDescription data-sentry-element="AlertDialogDescription" data-sentry-source-file="confirm-modal-standard.tsx">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter data-sentry-element="AlertDialogFooter" data-sentry-source-file="confirm-modal-standard.tsx">
          <Button variant="outline" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="confirm-modal-standard.tsx">
            {cancelText}
          </Button>
          <Button variant="destructive" onClick={onConfirm} data-sentry-element="Button" data-sentry-source-file="confirm-modal-standard.tsx">
            {confirmText}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>;
}